import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Toaster, toast } from "react-hot-toast";
import ManageUserService from "../../../api/ManageUserService";

class CreateOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createByAdmin: false,

      formValues: {},
      isLoading: false,
    };
  }

  componentDidMount = () => {
    console.log("eeeeeee", this.props);

    if (
      this.props.editValue &&
      Object.keys(this.props.editValue).length > 0 &&
      this.props.option === "edit"
    ) {
      const { editValue } = this.props;

      // Change the keys 'phone_no' to 'phoneNo' and 'mailID' to 'email'
      const { phone_no, mailID, ...otherValues } = editValue;
      const updatedEditValue = {
        phoneNo: phone_no,
        email: mailID,
        ...otherValues,
      };

      this.setState({
        formValues: updatedEditValue,
        createByAdmin: this.props.editValue.createByAdmin,
      });
    }

    toast.dismiss();
  };

  render() {
    const { formValues, isLoading } = this.state;
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h5 style={{ fontWeight: "bolder" }}>
              { this.props.option === "edit" ? "Edit " : "Add "}
              { this.props?.createEmployer ? "Employer" : "Employee" }
            </h5>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label> First Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="First Name"
                autoFocus
                className="small-input"
                name="firstName"
                value={formValues.firstName}
                onChange={this.onChangeformValues}
                style={{ height: "40px" }}
              />
            </Form.Group>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Last Name"
                autoFocus
                className="small-input"
                name="lastName"
                value={formValues.lastName}
                onChange={this.onChangeformValues}
                style={{ height: "40px" }}
              />
            </Form.Group>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                // placeholder="Email"
                autoFocus
                className="small-input"
                name="email"
                disabled={this.props.option === "edit"}
                value={formValues.email}
                onChange={this.onChangeformValues}
                style={{ height: "40px" }}
              />
            </Form.Group>

            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                // placeholder="Phone Number"
                autoFocus
                className="small-input"
                name="phoneNo"
                value={formValues.phoneNo}
                onChange={this.onChangeformValues}
                style={{ height: "40px" }}
              />
            </Form.Group>

            {/* <Row>
              <Col style={{ marginBottom: "9px" }}>
                <label
                  style={{
                    // fontWeight: "400",
                    marginBottom: "10px",
                    fontWeight: 500,
                  }}
                  className="CustomFormLabel"
                >
                  {"SpecialCustomer"}
                </label>
                <div style={{ marginLeft: "3px" }}>
                  <div class="checkbox-wrapper-19">
                    <input
                      type="checkbox"
                      id="cbtest-19"
                      name="createByAdmin"
                      checked={this.state.createByAdmin}
                      onClick={(e) => this.handlechangechecked(e)}
                    />
                    <label for="cbtest-19" class="check-box" />
                  </div>
                </div>
              </Col>
            </Row> */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Cancel
            </Button>

            <Button
              variant="success"
              type="button"
              onClick={this.saveEmployee}
              style={{ width: "11rem" }}
            >
              {isLoading && <span className="loader-button" />}
              <span>
                { this.props.option === "edit" ? "Edit " : "Add "}
                { this.props?.createEmployer ? "Employer" : "Employee" }
                {/* {this.props.option === "edit"
                  ? "Edit Employee"
                  : "Add Employee"} */}
              </span>
            </Button>
          </Modal.Footer>
        </Modal>
        <Toaster />
      </>
    );
  }

  handlechangechecked2 = () => {
    this.setState({
      female: !this.state.female,
      male: false,
    });
  };

  // to handlechanged checked to keromeos  as true  to set value
  handlechangechecked = () => {
    this.setState(
      {
        createByAdmin: !this.state.createByAdmin,
      },
      () => {
        console.log("this.state", this.state.createByAdmin);
      }
    );
  };

  onChangeformValues = (event) => {
    let form = { ...this.state.formValues };
    form[event.target.name] = event.target.value;
    this.setState(
      {
        formValues: form,
      },
      () => {
        console.log("formValues", this.state.formValues);
      }
    );
  };

  saveEmployee = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (this.props.option === "edit") {
      if (!this.state.formValues.firstName) {
        this.props.errorToast("Please Enter a First Name");
      } else if (
        !this.state.formValues.email ||
        !emailRegex.test(this.state.formValues.email)
      ) {
        this.props.errorToast("Please Enter a Valid Email");
      } else {
        let form = { ...this.state.formValues };

        // form["createByAdmin"] = this.state.createByAdmin;
        form["profileImage"] = "";
        form["profileCoverImage"] = "";
        // form["userId"] = parseInt(AuthService.getUserId());
        this.setState({ isLoading: true });

        ManageUserService.EditOwnerByAdmin(form).then((response) => {
          console.log("response", response);
          console.log("response", response.data.message);

          if (response.data && response.data.message === "Success") {
            this.props.handleClose();
            this.props.onLoad();
            this.props.renderToast("Edit");
            this.setState({ isLoading: false });
          } else {
          }
        });
      }
    } else {
      console.log("this.state.formvalues", this.state.formValues);
      console.log("createByAdmin", this.state.createByAdmin);
      if (!this.state.formValues.firstName) {
        this.props.errorToast("Please Enter First Name");
      } else if (
        !this.state.formValues.email ||
        !emailRegex.test(this.state.formValues.email)
      ) {
        this.props.errorToast("Please Enter a Valid Email");
      } else {
        let form = { ...this.state.formValues };

        form["createByAdmin"] = this.state.createByAdmin;

        form[
          "url"
        ] = `${window.location.origin}/FarmShopConnectAdmin/ResetPassword?id=`;
        // form["userId"] = parseInt(AuthService.getUserId());

        console.log("form", form);
        this.setState({ isLoading: true });
        ManageUserService.CreateOwnerByAdmin(form).then((response) => {
          console.log("response", response);
          console.log("response", response.data.message);

          if (response.data && response.data.message === "Success") {
            this.props.handleClose();
            this.props.onLoad();
            this.props.renderToast("Create");
            this.setState({ isLoading: false });
          } else if (response.data.message === "Email_Already_Exits") {
            this.props.errorToast("Email Already Exist");
          } else {
          }
        });
      }
    }
  };
}
export default CreateOwner;
